import { Link } from "@tanstack/react-router";
import { badgeVariants } from "@workspace/web-ui/components/badge";
import { cn } from "@workspace/web-ui/lib/utils";

interface SubNavProps {
  title: string;
  buttonOne?: string;
  buttonTwo?: string;
}

const SubNav = ({ title, buttonTwo }: SubNavProps) => {
  return (
    // <nav className="flex flex-wrap h-14 items-center gap-3 pb-4">
    //   <h5 className="flex-1 text-[40px] font-semibold">{title}</h5>
    //   {buttonOne ? <Button className="h-11 w-44 hidden lg:flex bg-white px-4 py-3 text-[#666670] hover:bg-gray-50 hover:text-black rounded-lg">
    //     {buttonOne}
    //     <ChevronRight />{" "}
    //   </Button> : null}
    //   {buttonTwo ? <Button className="h-11 w-44 bg-[#4272DD] rounded-lg px-4 py-3 text-white">
    //     {buttonTwo}
    //   </Button> : null}

    // </nav>
    <nav className="flex flex-row sm:items-center items-start gap-3 pb-4">
      <h5 className="w-full sm:flex-1 text-[24px] sm:text-[40px] font-semibold">
        {title}
      </h5>

      {/* {buttonOne && (
    <Button className="h-11 w-full sm:w-44 hidden lg:flex bg-white px-4 py-3 text-[#666670] hover:bg-gray-50 hover:text-black rounded-lg">
      {buttonOne}
      <ChevronRight />
    </Button>
  )} */}

      {buttonTwo && (
        <Link to="/dashboard/weight-loss/appointments/booking" className={cn(badgeVariants({ variant: "default" }), "h-11 inline-flex bg-[#4272DD] text-center text-nowrap rounded-lg px-4 py-3 text-white")}>
          {buttonTwo}
        </Link>
      )}
    </nav>

  );
};

export default SubNav;
